<template>
  <div style="height: 100%;">
	<div class="picMagnify df fdc jcc aic" :class="{picMagnifyLeft:leftRight,picMagnifyRight:!leftRight}" style="z-index: 99999999;" v-if="imgOff">
		<div 
			v-if="imgName && imgName.length > 0"
			class="wp94 ptb5 plr5 b_bai df jcc aic fww"
		>{{ imgName }}</div>
		
		<div class="picMagnifyTwo">
			<img class="picMagnifyImg" :src="src">
		</div>
	</div>
    <router-view></router-view>
  </div>
</template>
  
<script>
	import {startTimer,stopTimer} from '@/timer/index.js'

	export default {
		name: 'App',

		data() {
			return {
				leftRight:true,
				imgOff:false,
				imgName:'',
				src:'',
			}
		},

		created() {
			var that = this;
			// 同步缓存数据
			that.saveState()
			startTimer();

			that.util.setUrlOn('webAppOn',that,function(data){
				that.sendMsg(data)
			});
		},

		// 销毁之前
		beforeUnmount() {
			stopTimer();
			this.util.delOn(this);
		},

		mounted(){
			
		},

		methods: {

			sendMsg(data){
				var that = this;
				if(data.msg_way == 'up_gps'){
					for(var key in data.data.number){
						that.$eventBus.emit('/'+key+'/echarts/gps', data.data);
					}
				}
			},

			imgShow(src = '',leftRight = 1,name = ''){
				this.imgOff = true
				this.leftRight = leftRight
				this.imgName = name
				this.src = src
			},

			imgHide(){
				this.imgOff = false
			},

			// 同步缓存数据
			saveState() {
				// 在页面加载时读取sessionStorage
				if (sessionStorage.getItem('store')) {
					this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
				}

				// 在页面刷新时将store保存到sessionStorage里
				window.addEventListener('beforeunload', () => {
					sessionStorage.setItem('store', JSON.stringify(this.$store.state))
				})

				this.$store.state.isMobile = this.isMobileFun();
			},

			isMobileFun() {
				// 这里使用了一个简单的正则表达式来判断userAgent中是否包含常见的移动设备字符串  
				// 注意：这个正则表达式可能需要根据实际情况进行调整  
				const ua = navigator.userAgent.toLowerCase();  
				const isAndroid = /android/.test(ua);  
				const isiOS = /iphone|ipad|ipod/.test(ua);  
				// 也可以添加对Windows Phone、BlackBerry等其他移动操作系统的检测  
				// 但这里为了示例简洁，只检测Android和iOS  
				return isAndroid || isiOS;  
			}
		},
	}

	// ResizeObserver loop completed with undelivered notifications.
	// 解决ResizeObserver循环完成但未送达通知的问题
	const debounce = (fn, delay) => {
		let timer = null;
		return function () {
			let context = this;
			let args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
			fn.apply(context, args);
			}, delay);
		}
	}

	const _ResizeObserver = window.ResizeObserver;
		window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
		constructor(callback) {
			callback = debounce(callback, 16);
			super(callback);
		}
	}
</script>


<style lang="less">
  // 全局css
	@import '@/style/global.less';

	#app {
		height: 100vh;
		background: #F2F3F5;
	}

	.el-button--primary{
		--el-button-bg-color:#409EFF;
		--el-button-text-color:#eee;
	}

	.el-row{
		width: 100%;
	}

	.el-table__inner-wrapper{
		height: 100% !important;
	}

	.el-table__body-wrapper{

		.butList{
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;

			.el-button+.el-button{
				margin-left: 0px !important;
				margin-top: 5px;
				margin-bottom: 5px;
			}
		}
	}

	/* 图片放大 */
    .picMagnify{
        width:calc(50% - 15px);
        height: calc(90% - 10px);
        position:fixed;
        top:5%;
        z-index: 9999;
        background:rgba(0,0,0,0.5);
        padding:5px;
        // display:none;
    }

	.picMagnifyTwo{
		width:100%;
        height: 100%;
		position: relative;
	}

    .picMagnifyImg{
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }

    .picMagnifyLeft{
        left:5px;
    }

    .picMagnifyRight{
        right:5px;
    }

    .showPic{
        cursor:pointer;
    }

    .showPicCursor{
        cursor:pointer;
    }
    /* 图片放大 end */

	// 滚动条样式
	.mytable-scrollbar {
		::-webkit-scrollbar {
			// width: 8px;
			height: 8px;
		}
		::-webkit-scrollbar-thumb {
			border-radius: 4px;
		}
	}

	// 居中
	// .lineTable{
	// 	.vxe-table--body{
	// 		.vxe-body--column{
	// 			.vxe-cell{
	// 				width: 100%;
	// 				height: 100%;
	// 				display: flex;
	// 				// justify-content: center;
	// 				align-items: center;
	// 				flex-wrap: wrap;
	// 			}
	// 		}
	// 	}
	// }
  
</style>

